import { ComposedTheme, createUseStyles } from '@glu/theming';

const styles = ({ formComponents }: ComposedTheme) => ({
  dark: {},
  inCheckboxRadio: {
    position: 'relative',
    left: formComponents.checkboxLabel.marginLeft,
  },
  root: {
    ...formComponents.error,
    alignSelf: 'center',
    lineHeight: 1,
    margin: 0,
  },
  warning: {},
  wrap: {
    '& svg': {
      display: formComponents.error.iconDisplay,
      fill: formComponents.error.color,
      marginRight: 8,
    },
    '&$dark': {
      '& $root': {
        color: formComponents.dark.error.color,
      },
      '& svg': {
        fill: formComponents.dark.error.color,
      },
      '&$warning': {
        '& $root': {
          color: formComponents.dark.warning.messageColor || formComponents.dark.warning.color,
        },
        '& svg': {
          fill: formComponents.dark.warning.iconColor,
        },
      },
    },
    '&$inCheckboxRadio': {
      marginTop: 2,
    },
    '&$warning': {
      '& $root': {
        color: formComponents.warning.messageColor || formComponents.warning.color,
      },
      '& svg': {
        fill: formComponents.warning.iconColor,
      },
    },
    alignItems: 'flex-start',
    display: 'flex',
    margin: [8, 0, 0],
  },
});

export default createUseStyles(styles);
